enum EnumOperator {
  None = 0,
  Add = 1,
  Subtract = 2,
  Multiply = 3,
  Divide = 4,
}

function PeakOperator(variable1: number, variable2: number, operator: EnumOperator): number {
  let output = 0;
  variable1 = variable1.ToNumber();
  variable2 = variable2.ToNumber();
  const decimalNumberVariable1 = variable1.ToNumber().GetDecimalNumber();
  const decimalNumberVariable2 = variable2.ToNumber().GetDecimalNumber();
  let decimalNumber = 1;
  if (decimalNumberVariable1 !== 0 || decimalNumberVariable2 !== 0) {
    decimalNumber = decimalNumberVariable1 > decimalNumberVariable2 ? decimalNumberVariable1 : decimalNumberVariable2;
  }
  const divisor = Math.pow(10, decimalNumber);
  switch (operator) {
    case EnumOperator.Add:
      output = (variable1 * divisor + variable2 * divisor) / divisor;
      break;
    case EnumOperator.Subtract:
      output = (variable1 * divisor - variable2 * divisor) / divisor;
      break;
    case EnumOperator.Multiply:
      output = (variable1 * divisor * (variable2 * divisor)) / (divisor * divisor);
      break;
    case EnumOperator.Divide:
      output = (variable1 * divisor) / (variable2 * divisor);
      break;
  }
  return output;
}

export default {
  PeakOperatorAdd(variable1: number, variable2: number): number {
    return PeakOperator(variable1, variable2, EnumOperator.Add);
  },
  PeakOperatorSubtract(variable1: number, variable2: number): number {
    return PeakOperator(variable1, variable2, EnumOperator.Subtract);
  },
  PeakOperatorMultiply(variable1: number, variable2: number): number {
    return PeakOperator(variable1, variable2, EnumOperator.Multiply);
  },
  PeakOperatorDivide(variable1: number, variable2: number): number {
    return PeakOperator(variable1, variable2, EnumOperator.Divide);
  },
};
